// extracted by mini-css-extract-plugin
export default {"root":"styles_root__LzH3m","navigation":"styles_navigation__DpQ1c","prev":"styles_prev__kgwU0","next":"styles_next__QRkJB","add":"styles_add__vSTPg"};